/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyPrioritySchemes: LazyComponent<() => React.JSX.Element> = lazyForPaint(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-admin-pages-priority-schemes", jiraSpaEntry: "async-admin-pages-priority-schemes" */ '@jira/admin-pages__priority-schemes/src/PrioritySchemesPage.tsx'
		),
	),
);

const AsyncPrioritySchemes = (): React.JSX.Element => (
	<LazyPage
		Page={LazyPrioritySchemes}
		pageId="jira-admin-pages-priority-schemes"
		shouldShowSpinner
	/>
);

export default AsyncPrioritySchemes;
